import type { MessengerMessage } from '@/api/client';
import type { TrackerChatMessage } from '@/components/Messenger/types/chatMessageTypes';
import { isMessengerImageMime } from '@/components/Messenger/shared/attachments/messengerImageMime';

export type MessengerFileAttachmentTarget = {
  kind: 'image' | 'file';
  url: string;
  fileName: string;
};

function defaultImageName(fileName: string | null | undefined): string {
  const n = fileName?.trim();
  return n || 'image.jpg';
}

function defaultFileName(fileName: string | null | undefined): string {
  const n = fileName?.trim();
  return n || 'Файл';
}

/** Встроенное изображение или файловое вложение DM/группы (не context project/session). */
export function resolveDmMessageFileTarget(
  msg: Pick<MessengerMessage, 'file_url' | 'mime_type' | 'file_name' | 'deleted_at'>,
): MessengerFileAttachmentTarget | null {
  if (msg.deleted_at) return null;
  const url = msg.file_url?.trim();
  if (!url) return null;
  if (isMessengerImageMime(msg.mime_type)) {
    return { kind: 'image', url, fileName: defaultImageName(msg.file_name) };
  }
  return { kind: 'file', url, fileName: defaultFileName(msg.file_name) };
}

/** Первое file-вложение в parts агентского сообщения (одно вложение по продукту). */
export function resolveAgentPartsFileTarget(
  parts: TrackerChatMessage['parts'] | undefined,
): MessengerFileAttachmentTarget | null {
  if (!parts?.length) return null;
  for (const part of parts) {
    if (part.type !== 'file' || !('url' in part)) continue;
    const url = typeof part.url === 'string' ? part.url.trim() : '';
    if (!url) continue;
    const mediaType = 'mediaType' in part ? part.mediaType : undefined;
    const fileName =
      'filename' in part && typeof part.filename === 'string'
        ? part.filename
        : undefined;
    if (isMessengerImageMime(mediaType)) {
      return { kind: 'image', url, fileName: defaultImageName(fileName) };
    }
    return { kind: 'file', url, fileName: defaultFileName(fileName) };
  }
  return null;
}
